import RightsRequestChildren from "./RightsRequestChildren"

export default RightsRequestChildren
